import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";

import AccountInfo from "./AccountInfo";
import ProfileAvatar from "./ProfileAvatar";
import { SettingsStyles } from "./SettingsStyles";

const Settings = () => {
  const { adminDetails } = useAppSelector(
    (state: RootState) => state.adminAuth
  );

  const handleImageChange = (file: File) => {
    console.log("New image file:", file);
    // Handle image upload logic here
  };

  return (
    <Box sx={SettingsStyles.SettingsContainer}>
      <Typography variant="h6" sx={SettingsStyles.AccountSettingsHeading}>
        Account Settings
      </Typography>
      <Grid container spacing={3}>
        <Grid lg={3} md={4} xs={12} item>
          <Card sx={SettingsStyles.AvatarCard}>
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              <ProfileAvatar
                initials={
                  adminDetails?.name?.slice(0, 2)?.toUpperCase() || "NA"
                }
                onImageChange={handleImageChange}
              />
              <Typography sx={{ marginTop: 2 }}>
                {adminDetails?.email}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {adminDetails?.name}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid lg={9} md={8} xs={12} item>
          <AccountInfo />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Settings;
